// extracted by mini-css-extract-plugin
module.exports = {"root":"DaylongMoreBtn_root__1RQlM","accent":"DaylongMoreBtn_accent__64RHP"};